<template>
  <Detail :id="id"></Detail>
</template>

<script>
// @ is an alias to /src
import Detail from "@/components/template-categories/Detail";

export default {
  name: "TemplateCategoryDetail",
  components: {
    Detail
  },
  data() {
    return {
      id: null,
    };
  },
  created() {
    this.id = parseInt(this.$route.params.id)
  },
  mounted() {

  },
};

</script>
